import { combineReducers } from "redux-immutable";

import filterReducers from "./filter";

export default combineReducers({
	filter: filterReducers
});
